import Area from './Area';

export default class Location {
    static fromData(data) {
        if (!data) {
            return;
        }

        let location = new Location();

        location.id = data.id || null;
        location.name = data.name;
        location.shortName = data.shortName;
        location.note = data.note;
        location.type = data.type;
        location.street = data.street;
        location.addressCo = data.addressCo;
        location.postalCode = data.postalCode;
        location.city = data.city;
        location.size = data.size;
        location.maxPersons = data.maxPersons;
        location.areas = data.areas.data.map(data => Area.fromData(data));
        location.hasImage = data.hasImage;
        location.imageUrl = data.imageUrl;
        location.hierarchyPath = data.hierarchyPath;
        location.isArchived = data.isArchived;
        location.isViewable = data.isViewable;
        location.isEditable = data.isEditable;
        location.isDeletable = data.isDeletable;

        Object.seal(location);
        return location;
    }

    equals(location){
        if (location.id === null) {
            return false;
        }
        return location.id === this.id;
    }
}
